import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  Radio,
  Form,
  Input,
  Select,
  Button,
  Steps,
  Modal,
  message,
  Upload,
  Spin,
  Checkbox,  
} from "antd";
import "./signupnew.scss";
import qhrflow from "../assets/landingFeatures/qhrFlow.png";
import imgNujobs from "../assets/landingFeatures/explorer.png";
import { actions } from "../actions";
import "./signup.css";
import { useDispatch } from "react-redux";
import moment from 'moment'
import CertificateAddModal from "../components/certificateAddModal";
import { Document, Page, pdfjs } from 'react-pdf';
import { LoadingOutlined } from "@ant-design/icons";


export default function SignupNew() {
    const [loader, SetLoader] = useState(false);
    const [formKey1, setFormKey1] = useState(1);
    const [currentView, setCurrentView] = useState("signup-1")
    const [currentIdx, setCurrentIdx] = useState(0)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const[error,setError] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const moment = require('moment');
    const [certificateModalOpen, setCertificateModalOpen] = useState(false);
    const [documentFile, setDocumentFile] = useState(null);
    const { product } = useParams();
    
    const [inputData, setFormData] = useState({
      username: "",
      organization: " ",
      contact: "",
      email: "",
      account_type: "",
      permission:"superadmin",
      designation:"",
      weburl:"",
      address:"",
      city:"",
      country:"",
      pincode:"",
      planname:"",
      subscriptionperiod:"trialonly",
      trialperiod:"",
      amount:"",
      bu_team:"",
      document : null,
      // Terms & Privacy
      termsaccepted: false,
      privacyaccepted: false,
      termsversion: "1.0",
      privacypolicyversion: "2026-09-13"      
    });

  const [productname, setProductName] = useState("");
  useEffect(() => {
            if(product === "nujobs"){
               setProductName("NuJobs")
            } else if(product === "qhrset"){
               setProductName("QHRSet")
            } else{
               setProductName("QHRFLOW")
            }
        }, []);

    useEffect(() => {
      //comments

      dispatch(actions.GetProductPlans(product, (error, status) => {
        if (!error) {
          const planData = JSON.parse(localStorage.getItem("productPlans"));
          const selectedPlan = planData?.find((plan) => plan.planname === "QuallyHire Launch" || plan.planname === "NuJobs Launch");
          if (selectedPlan) {
            setFormData({ ...inputData, ["planname"]: selectedPlan.planname, ["trialperiod"]: selectedPlan.trialperiod });
          }
        } else {
          // Handle the error case
          console.error("API Error:", error);
          setError(error)
        }
      }));
    }, []);

    const handleFormSubmit = (values) => {
        
    };

    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const handleCreateAccount = (values) =>{
      // Validate mandatory fields
      const requiredFieldNames = ['username', 'contact', 'email', 'designation', 'organization', 'weburl', 'account_type', 'address', 'city', 'country', 'pincode', 'planname', 'subscriptionperiod'];
      const missingFields = requiredFieldNames.filter(field => !inputData[field] || inputData[field].trim() === "");

      // Check if any required field is empty
      if (missingFields.length > 0) {
        setError(`Please provide mandatory data: ${missingFields.join(', ')}`);
        showModal();
        return;
      }

      // Validate Terms of Use and Privacy Policy
      if (!inputData.termsaccepted || !inputData.privacyaccepted) {
        setError(
          "Please agree to the Terms of Use and acknowledge the Privacy Policy before creating your account."
        );
        showModal();
        return;
      }
      
      // Create FormData for multipart submission
      //const formData = new FormData();
      inputData.productsignon = product
      SetLoader(true);

      console.log("Submitting Signup Data:", inputData); // Log the data being submitted
      dispatch(actions.Signup(inputData, (error, status) => {
        if (!error) {
          navigate(`/otpprocess/${product}`, { state: { reason:"verifyotp", trigger: "signup" ,signupemail:inputData.email} });
          SetLoader(false);
        } else {
          // Handle the error case
          SetLoader(false);
          console.error("API Error:", error);
        
          if( error === "decode error"){
            setError("Kindly fill right details." );
          }else if( error === "please sign in"){
            setError("Account already created, kindly sign in.");
          }else if( error === "verification pending"){
            setError("OTP Verification pending, Kindly verify your email id.");
          }else {
            setError(error)
          }
          showModal()
          console.log("status", status);
        }
      }));
    }    
    const ProductPlansInfo = () =>{
      const planData = JSON.parse(localStorage.getItem("productPlans"));
      const planDropDown = planData?.filter((plan) => plan.planname === "QuallyHire Launch" || plan.planname === "NuJobs Launch" ).map((plan,idx) => {
        return {
          value: plan.planname + "_" +plan.trialperiod,  
          label: plan.planname
        };
      });
      //console.log("Plan Data",planData);
      //console.log("Plan Data",planDropDown);
      return planDropDown
  }
    const handleChangePlan = (value) =>{
      const plan_array = value.split("_");
      var period = plan_array[1];
      var name = plan_array[0];

      //console.log("handle change", value)
      setFormData({ ...inputData, ["planname"]: name ,["trialperiod"]:period});
    }
    const handleChange = (event) =>{

      const { name, value } = event.target;     
      //console.log("handle change", value)
      setFormData({ ...inputData, [name]: value.trim()});
    }

    const OnSelectChange = (value) =>{
      //const { name, value } = value;     
      //console.log("handle change", value)
      setFormData({ ...inputData, ['designation']: value});
    }

    const officialEmailPattern =
            /^(?!.*@(gmail|googlemail|yahoo|hotmail|outlook|live|msn|icloud|aol|protonmail|proton|rediffmail|zoho)\.).+@.+\..+$/i;

    const handlesignup1 = (values) => {
      setCurrentView("signup-1")
      setCurrentIdx(0)
    };
    const handlesignup2 = (values) => {
      setCurrentView("signup-2")
      setCurrentIdx(1)
    };
    const handlesignup3 = (values) => {
      setCurrentView("signup-3")
      setCurrentIdx(2)
    };

  const handleConsentChange = (event) => {
    const checked = event.target.checked;

    setFormData(prev => ({
      ...prev,
      termsaccepted: checked,
      privacyaccepted: checked
    }));
  };

    const handlesignup4 = (values) => {
      setCurrentView("signup-4")
      setCurrentIdx(3)
    };

    const handleStateChange = (value) => {
      if(value ===0) handlesignup1(0)
      else if(value ===1) handlesignup2(1)
      else if(value ===2) handlesignup3(2)
      else if(value ===3) handlesignup4(3)    
    };

    return (
    <div className="signupnew-wrapper">
        <div className="signupnew-form-wrapper">
          <CertificateAddModal
            certificateModalOpen={certificateModalOpen}
            setCertificateModalOpen={setCertificateModalOpen}
            companyName={inputData.organization}
            email={inputData.email}
            documentType={inputData.documentType}
          />
          <div className="signupnew-leftarea">
              <div className="leftarea-column">
                {
                  product === "nujobs"?
                  <>
                    <Link to = "/nujobs">
                      <img
                        src={imgNujobs}
                        alt="Explorer"
                        width="220" height="auto" 
                      />                 
                    </Link>
                  </>
                  :
                  <>
                      <Link to = "/home">
                        <img
                          src={qhrflow}
                          alt="Explorer"
                          width="200" height="200" 
                        />                 
                      </Link>
                  </>
                } 
              </div>     
              <div className="leftarea-column">
                {product === "nujobs"?
                  <>
                    <div className="nujobs-login-branding">
                      <h2>Easy Jobs Posting and Application Processing</h2>
                      <p> Quality Candidates.</p>
                    </div>  
                  </>
                  : product === "qhrset"?
                  <>
                    For Employer 
                  </>
                  :<>
                    Discover Talent, Drive Success. 
                  </>}  
              </div>   
          </div>

          <div className="signupnew-rightarea"> 
          <div className="signupnew-heading">
            {
              product ==="nujobs"?
              <>
                Sign Up to NuJobs <br></br>
              </>
              :product === "qhrset"?
              <>
                Sign Up to QHRSET <br></br>
              </>
              :<>Sign Up to QHRFLOW <br></br></>
            }                
          </div> 

          <Steps
            size="small"
            current={currentIdx}
            onChange={handleStateChange}
            items={[
              {
                title: 'Signup-Details',
              },
              {
                title: 'Company Details',
              },
              {
                title: 'Upload Documents',
              },
              {
                title: 'Plan Selection',
              },                          
            ]}
          />  
            <Form
              key={formKey1}
              className="profile-form"
              name="signon-form"
              justify="start"
              layout="vertical"
              autoComplete="off"
              onFinish={handleFormSubmit}
             >                     
            {currentView === "signup-1"?
            <>
                  <Form.Item
                      required = {true}
                      className="profile-field-item"
                      label="Your Name"
                      name="username"
                  >
                      <Input
                          required = {true}
                          className="profile-input"
                          onChange={handleChange}
                          name="username"
                      />
                  </Form.Item>

                <div className="signinnew-dual-input-wrapper">
                    <Form.Item
                      className="profile-field-item"
                      label="Mobile Number"
                      name="contact"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your mobile number",
                        },
                        {
                          pattern: /^\+[1-9]\d{7,14}$/,
                          message: "Enter a valid number with country code",
                        },
                      ]}
                    >
                      <Input
                        className="profile-input"
                        onChange={handleChange}
                        name="contact"
                        placeholder="+91.........."
                      />
                    </Form.Item>
                    <Form.Item                           
                            className="profile-field-item"
                            label="Email ID"
                            name="email"
                            normalize={(value) => value.trim().toLowerCase()}
                            rules={[
                              {
                                required: true,
                                message: "Please enter your official email address",
                              },
                              {
                                type: "email",
                                message: "Please enter a valid email address",
                              },
                              {
                                pattern: officialEmailPattern,
                                message: "Please use your official company email address",
                              },
                            ]}                            
                        >
                            <Input
                                required = {true}
                                className="profile-input"
                                onChange={handleChange}
                                placeholder="name@company.com"
                                name="email"
                            />
                    </Form.Item>                    
                </div>                                 

                <div className="signinnew-dual-input-wrapper">
                    <Form.Item
                            required = {true}                            
                            className="profile-field-item"
                            label="Role/Function"
                            name="designation"
                    >
                    <Select                          
                            required = {true}
                            className="profile-input"
                            onChange={OnSelectChange}
                            name="designation"
                            options={[
                                { value: 'Trainee Recruiter', label: 'Trainee Recruiter' },
                                { value: 'Recruiter', label: 'Recruiter' },
                                { value: 'Lead Recruiter', label: 'Lead Recruiter' },
                                { value: 'HR Manager', label: 'HR Manager'},
                                { value: 'Group Manager', label: 'Group Manager' },
                                { value: 'Procurement Team', label: 'Procurement Team'}, 
                                { value: 'Tech Lead', label: 'Tech Lead'}, 
                                { value: 'Manager', label: 'Manager'}, 
                                { value: 'COO', label: 'COO' },
                                { value: 'CHRO', label: 'CHRO' },
                                { value: 'CEO', label: 'CEO'},                                 
                                { value: 'Others', label: 'Others' },
                            ]}
                    />                    
                    </Form.Item>                      
                    <Form.Item
                            className="profile-field-item"
                            label="BU/Group"
                            name="bu_team"
                        >
                            <Input
                                className="profile-input"
                                onChange={handleChange}
                                name="bu_team"
                            />
                    </Form.Item>
                </div>
              
                <Button
                    style={{ width: "100%", height: "40px", fontWeight: "600" }}
                    type="primary"
                    htmlType="submit"
                    onClick={handlesignup2}
                >
                     Save and Go To Next Step
                </Button>
             </>
             : currentView === "signup-2"?
             <>
                 <Form.Item
                     label="Organization Name"
                     name="organization"
                className="profile-field-item"
                rules={[
                  {
                    required: true,
                    message: "Please enter your organization name",
                  },
                  {
                    min: 4,
                    message:
                      "Organization name must be at least 4 characters long",
                  },
                ]}
                 >
                     <Input
                         required = {true}
                         className="profile-input"
                         onChange={handleChange}
                         name="organization"
                     />
               </Form.Item> 

                 <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please enter your company website",
                        },
                        {
                          type: "url",
                          message: "Please enter a valid website URL",
                        },
                      ]}                    
                     className="profile-field-item"
                     label="Organization Website URL"
                     name="weburl"
                 >
                     <Input
                        required = {true}
                         className="profile-input"
                         onChange={handleChange}
                         name="weburl"
                         placeholder="https://www.company.com"
                     />
               </Form.Item> 

             <Form.Item
                 required = {true}
                 className="profile-field-item"                 
                 label="Select what describes you Best"
                 name="account_type"
             >
                 <Radio.Group
                     className="profile-radio-wrapper"
                     onClick
                     onChange={handleChange}
                     name="account_type"
                 >
                     <Radio
                         className="radio-option"
                         value="ProductOrg"
                     >
                         Product Company
                     </Radio>
                     <Radio
                         className="radio-option"
                         value="ServiceOrg"
                     >
                         Services Company
                     </Radio>

                     <Radio
                         className="radio-option"
                         value="StaffingOrg"
                     >
                         Staffing/Recruitment Company
                     </Radio>
                 </Radio.Group>
             </Form.Item>
             <div className="signinnew-dual-input-wrapper">
             <Form.Item
                         required = {true}                         
                         className="profile-field-item"
                         label="Address"
                         name="address"
                     >
                         <Input
                             required = {true}
                             className="profile-input"
                             onChange={handleChange}
                             name="address"
                         />
             </Form.Item>
             <Form.Item
                     required = {true}
                     className="profile-field-item"
                     label="City"
                     name="city"                    
                 >
                     <Input
                        required = {true}
                         className="profile-input"
                         onChange={handleChange}
                          name="city"
                     />
                 </Form.Item>
             </div>

             <div className="signinnew-dual-input-wrapper">
                 <Form.Item
                         required = {true}                         
                         className="profile-field-item"
                         label="Country"
                         name="country"
                     >
                         <Input                      
                             required = {true}
                             className="profile-input"
                             onChange={handleChange}
                             name="country"
                         />
                 </Form.Item>
                 <Form.Item
                         required = {true}
                         name="pincode"                         
                         className="profile-field-item"
                         label="Pin Code"
                     >
                         <Input
                             required = {true}
                             className="profile-input"
                             onChange={handleChange}
                             name="pincode"
                         />
                 </Form.Item>
             </div>              
             <Button
                 style={{ width: "100%", height: "40px", fontWeight: "600" }}
                 type="primary"
                 htmlType="submit"
                 onClick={handlesignup3}
             >
                 Save and Go To Next Step
             </Button>
             </>
             :currentView === "signup-3"?
              <>
              <Form.Item
                  required = {true}
                  className="profile-field-item"
                  label="Required Documents"
                  name="documenttype"
              >
              <Radio.Group
                      className="profile-radio-wrapper"
                      onClick
                      onChange={handleChange}
                      name="documenttype"
                  >
                      <Radio
                          className="radio-option"
                          value="registration-doc"
                      >
                          Any Company Registraion Certificate (e.g. GST, PAN, Company Incorporation, etc.)
                      </Radio>
                      <Radio
                          className="radio-option"
                          value="tax-certificate"
                      >
                          Your Business card
                      </Radio>
                  </Radio.Group>
              </Form.Item> 
              <div className="profile-field-item">
                  <Upload
                          beforeUpload={(file) => {
                          const isPdf = file.type === 'application/pdf';
                          if (!isPdf) {
                            message.error('You can only upload PDF files!');
                            return false;
                          }
                          // Store the file for multipart/form-data
                          // Convert file to binary and store it
                          // Store the file directly for FormData submission
                          setFormData(prev => ({ ...prev, document: file }));

                          // setFormData(prev => ({ ...prev, document: data }));
                          setDocumentFile(prev => ({
                                ...prev,
                                document: file,
                                currentPage: 1
                              }));
                              return false; // Prevent auto upload
                          }}
                          showUploadList={true}
                          accept=".pdf"
                          maxCount={1}
                  >
                    <Button style={{ width: "100%", height: "40px", fontWeight: "600" }}>
                        Upload Now
                    </Button>
                  </Upload>
              </div>    
              {documentFile?.document && (
              <div className="document-viewer" style={{ marginTop: "15px", border: "1px solid #d9d9d9", borderRadius: "6px", padding: "16px" }}>
                  <h4>Document Preview:</h4>
                  <Document
                  file={documentFile.document}
                  onLoadSuccess={({ numPages }) => {
                  console.log(`Loaded ${numPages} pages`);
                  setDocumentFile(prev => ({ ...prev, totalPages: numPages }));
                  }}
                  onLoadError={(error) => console.error('Error loading PDF:', error)}
                  >
                        <Page 
                        pageNumber={documentFile.currentPage || 1} 
                        width={400}
                        style={{ marginBottom: '10px' }}
                        />
                  </Document>
                {documentFile.totalPages > 1 && (
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <Button 
                  disabled={documentFile.currentPage <= 1}
                  onClick={() => setFormData(prev => ({ ...prev, currentPage: prev.currentPage - 1 }))}
                  style={{ marginRight: '10px' }}
                >
                  Previous
                </Button>
                <span>Page {documentFile.currentPage || 1} of {documentFile.totalPages}</span>
                <Button 
                  disabled={documentFile.currentPage >= documentFile.totalPages}
                  onClick={() => setFormData(prev => ({ ...prev, currentPage: prev.currentPage + 1 }))}
                  style={{ marginLeft: '10px' }}
                >
                  Next
                </Button>
                </div>
                )}
              </div>
              )}
              <div className="profile-field-item"  style={{ marginTop: "15px" }}>           
              <Button
                  style={{ width: "100%", height: "40px", fontWeight: "600" }}
                  type="primary"
                  htmlType="submit"
                  onClick={handlesignup4}
              >
                  Save and Go to Next Step
              </Button>
              </div>
              </> 
             :currentView === "signup-4"? 
             <>                             
              <Form.Item
                  required = {true}
                  className="profile-field-item"       
                  label="Plan Name"
                  name="planname"
              >
                  <Select
                      onChange={handleChangePlan}   
                      placeholder={inputData.planname}                                                          
                      options={ProductPlansInfo()}
                      className="profile-input"          
                  />
              </Form.Item>
              <Form.Item
                  required = {true}
                  className="profile-field-item"                 
                  label="Subscription Period"
                  name="subscriptionperiod"
              >
                  <Radio.Group
                      className="signup-radio-wrapper"
                      onClick
                      onChange={handleChange}
                      name="subscriptionperiod"
                      defaultValue="trialonly"
                  >
                      <Radio
                          className="radio-option"
                          value="trialonly"
                      >
                          Trial Only
                      </Radio>                    
                      <Radio
                          className="radio-option"
                          value="3"
                          disabled={true}
                      >
                          3 months
                      </Radio>
                      <Radio
                          className="radio-option"
                          value="6"
                          disabled={true}
                      >
                          6 Months
                      </Radio>

                      <Radio
                          className="radio-option"
                          value="12"
                          disabled={true}
                      >
                          12 Months
                      </Radio>
                  </Radio.Group>
              </Form.Item>
              {inputData.subscriptionperiod === "trialonly"?
              <>
                      <Form.Item
                          required = {true}
                          name="trialperiod" 
                          className="profile-field-item"
                          label="Trial Period"
                      >
                          <Input 
                              disabled                   
                              required = {true}
                              className="profile-input"
                              placeholder={inputData.planname===""?"":inputData.trialperiod}  
                              name="trialperiod"                            
                          />
              </Form.Item>
              </>:
              <></>}
              {/* Terms and Privacy Acceptance */}
              <div
                className="profile-field-item"
                style={{
                  marginTop: "10px",
                  marginBottom: "12px",
                  fontSize: "12px"
                }}
              >
                <Checkbox
                  checked={
                    inputData.termsaccepted &&
                    inputData.privacyaccepted
                  }
                  onChange={handleConsentChange}
                >
                  I agree to the{" "}
                  <Link
                    to="/terms-conditions"
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Terms of Use
                  </Link>{" "}
                  and acknowledge the{" "}
                  <Link
                    to="/privacy-policy"
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Privacy Policy
                  </Link>
                  .
                </Checkbox>

                <div
                  style={{
                    marginTop: "8px",
                    marginLeft: "24px",
                    color: "#666",
                    lineHeight: "1.5"
                  }}
                >
                  {product === "nujobs" ? (
                    <>
                      By creating an account, you understand that NuJobs may process
                      employer, recruiter, job, and recruitment-related information
                      to provide job posting, application management, recruitment,
                      and related services. Candidate information received through
                      NuJobs should be used only for legitimate recruitment and
                      hiring purposes.
                    </>
                  ) : product === "qhrset" ? (
                    <>
                      By creating an account, you understand that QHRSET may process
                      account, organization, evaluation, candidate, and
                      recruitment-related information to provide evaluation and
                      recruitment services.
                    </>
                  ) : (
                    <>
                      By creating an account, you understand that QHRFlow may process
                      recruitment-related information to provide applicant tracking,
                      resume processing, candidate search, matching, recruitment
                      workflows, and related services. You are responsible for
                      ensuring that you have appropriate rights and permissions to
                      provide candidate information to QHRFlow.
                    </>
                  )}
                </div>
              </div>             
              <Button
                  style={{ width: "100%", height: "40px", fontWeight: "600" }}
                  type="primary"
                  htmlType="submit"
                  onClick={handleCreateAccount}
              >
                {loader ? (
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ color: "white" }} spin />
                    }
                  />
                ) : (
                  "Create Account Now"
                )}
              </Button>
             </>
             :<></>             
            } 
            </Form>  
            {
              <Modal title="Signup" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                 {error}
              </Modal>
            }
        <div className="signupnew-links-wrapper"></div>
            <div className="signupnew-links-wrapper">             
              <div className="signupnew-links">
                <Link
                  to={`/otpprocess/${product}`}
                  state= {{ reason: "start" ,trigger: "signin"}} 
                > 
                  Sign In
                </Link>
              </div> 
              <div className="signupnew-links">
                <Link
                  to={`/otpprocess/${product}`}
              state={{ reason: "alreadygot", trigger: "signup" }}
            >
              Got Valid OTP?
            </Link>
          </div>

          <div className="signupnew-links">
            <Link to={`/signup/${product}`}>New Account Sign up</Link>
          </div>
        </div>
      </div>
      </div>
      <div className="otpprocess-footer">
        <div>
          <p>
            {productname} is an QUALLYHire AI Product Family from HMW Communications
            Pvt. Ltd.
          </p>
        </div>
        <div>
          <a>
            <p>
              Already have an account ? <Link to={`/otpprocess/${product}`}> Sign in</Link>
            </p>
          </a>
        </div>
      </div>      
    </div>

  );
}
